module.exports = __webpack_public_path__ + "img/C04TechRamShipS_ua.3bd6fd47.webp";